import React, {FC, ReactElement, useEffect, useState} from "react";
import {billingApi} from "../../backend/BillingApi";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {StartCardSetupDto} from "../../model/billing/StartCardSetupDto";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {Alert, Button, CircularProgress, Grid} from "@mui/material";
import {StripeCardElementOptions} from "@stripe/stripe-js";

interface IProps {
    onSuccess?: () => void,
    onCancel?: () => void
}

export const LinkNewDefaultCard: FC<IProps> = ({onCancel, onSuccess}): ReactElement => {
    const [startCardSetup, setCardSetup] = useState<StartCardSetupDto>();
    useEffect(() => {
        billingApi.startCardSetup(selectedCompanyStore.companyId)
            .then(setCardSetup)
    }, []);

    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState('');
    const [processing, setProcessing] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const stripe = useStripe()!!;
    const elements = useElements()!!;

    const cardStyle: StripeCardElementOptions = {
        style: {
            base: {
                color: "#32325d",
                fontFamily: 'Arial, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#32325d"
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            },
        },
        hidePostalCode: true
    };


    const handleChange = async (event: any) => {
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };

    const handleSubmit = async (ev: any) => {
        ev.preventDefault();
        setProcessing(true);
        const payload = await stripe.confirmCardSetup(startCardSetup?.secret!!, {
            payment_method: {
                card: elements.getElement(CardElement)!!
            }
        });
        if (payload.error) {
            setError(`Payment failed ${payload.error.message}`);
            setProcessing(false);
        } else {
            setError('');
            try {
                await billingApi.assignAsDefaultPaymentMethod(selectedCompanyStore.companyId, payload.setupIntent.id)
                if (onSuccess) {
                    await onSuccess();
                }
                setProcessing(false);
                setSucceeded(true);
            } catch (e) {
                setError('Failed to assign as default method');
                console.error(e)
            }
        }
    };

    return <>
        <form id="payment-form" onSubmit={handleSubmit} style={{width: "22rem"}}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <div>
                        <CardElement id="card-element" options={cardStyle} onChange={handleChange}/>
                    </div>
                    {error && (
                        <Alert severity="error">
                            {error}
                        </Alert>
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Button
                        startIcon={processing ? <CircularProgress size={"1rem"}/> : undefined}
                        variant={"contained"} color={"primary"} type={"submit"} disabled={processing || disabled || succeeded || !!error || !startCardSetup} id="submit">Link the
                        card</Button>
                    {onCancel && <Button variant={"contained"} color={"secondary"} onClick={onCancel}>Cancel</Button>}
                </Grid>
            </Grid>
        </form>
    </>;
};
